import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { TenantProvider } from '@/contexts/TenantContext';
import App from '@/App';
import '@/index.css';

// Apply stored palette on load — must match the key/default used by
// ThemePicker (components/common/ThemePicker.tsx: 'raftel_palette' / 'parchment')
// so pages rendered outside AppLayout (login, register, public leaderboard)
// pick up the owner's saved theme instead of always forcing midnight.
const palette = localStorage.getItem('raftel_palette') ?? 'parchment';
document.documentElement.setAttribute('data-palette', palette);

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <TenantProvider>
          <App />
        </TenantProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
